import translate from '@translate';
import React, { FC } from 'react';
import BodyTopBlock from 'src/components/BodyTopBlock';
import { DeleteIcon } from 'src/components/SkladonIcon/SmallIcons';
import { OrderMessagesOnExpeditionBoxType } from 'src/types/orderMessagesOnExpeditionBox';

export interface TopBlockPropsType {
    data: OrderMessagesOnExpeditionBoxType | null;
    idOrderMessagesOnExpeditionBox: string | undefined;
    disableEdit: boolean;
    permissionDelete: boolean;
    handleSave: () => void;
    handleDelete: () => void;
    newOrderMessagesOnExpeditionBox: boolean;
}

const TopBlock: FC<TopBlockPropsType> = (props) => {
    return (
        <>
            <BodyTopBlock
                actions={[
                    {
                        icon: <DeleteIcon />,
                        onClick: () => {
                            props.handleDelete();
                        },
                        tooltip: translate(
                            'orderMessagesOnExpeditionBoxDetail.action.deleteMessageOnExpeditionBoxDetail'
                        ),
                        hidden: !props.permissionDelete,
                        variant: 'outlined',
                    },
                    {
                        label: translate(
                            props.newOrderMessagesOnExpeditionBox
                                ? 'orderMessagesOnExpeditionBoxDetail.action.create'
                                : 'orderMessagesOnExpeditionBoxDetail.action.save'
                        ),
                        onClick: props.handleSave,
                        hidden: props.disableEdit,
                    },
                ]}
            />
        </>
    );
};

export default TopBlock;
